import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetReportSubscriptionResData } from "./GetReportSubscriptionResData";

const ENDPOINT = "/report_subscription/rs";

export class GetReportSubscriptionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetReportSubscriptionResData> {
        var res = await this.executeCommand();
        return new GetReportSubscriptionResData(res);
    }
}
